import { StContainer } from './StatsDivider.styled'

interface Props {
  className?: string
}

export const StatsDivider = ({ className }: Props) => {
  return <StContainer className={className} />
}
